import axios from "axios";
import CustomInterceptors from "@/api/Auth/GAInterceptors";

const instanceMasterData = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

instanceMasterData.interceptors.request.use(CustomInterceptors.GAInterceptors);

instanceMasterData.interceptors.response.use(response => {
  return response;
}, CustomInterceptors.GAInterceptorsOnError);

export default instanceMasterData;
